function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2Mobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3333333333333335,0,0,3.3333333333333335,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.19,9.42H14.75a.75.75,0,0,0,0,1.5h.63a.25.25,0,0,1,.24.25v.21a.75.75,0,0,0,.76.75.74.74,0,0,0,.74-.75V11s0-.06.07-.06a1.45,1.45,0,0,0,1.56-1.57c0-.93-.95-1.57-2-2.24a9,9,0,0,1-1.24-.93A.24.24,0,0,1,15.5,6H18a.75.75,0,0,0,0-1.5h-.62a.26.26,0,0,1-.26-.25V4.07a.75.75,0,0,0-.74-.75.76.76,0,0,0-.76.75v.41a.06.06,0,0,1-.06.06A1.41,1.41,0,0,0,14,6.1C14,7,15,7.67,16,8.35a7.93,7.93,0,0,1,1.24.94.18.18,0,0,1,.05.12Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.43,15.35A7.58,7.58,0,1,0,8.85,7.78,7.58,7.58,0,0,0,16.43,15.35Zm0-13.15a5.58,5.58,0,1,1-5.58,5.58A5.58,5.58,0,0,1,16.43,2.2Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.85h0L16.47,19a.28.28,0,0,0-.15.15,2,2,0,0,1-1.82,1.18h-4a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4a1,1,0,0,0,0-2H11a7.11,7.11,0,0,0-4-1.5H4.94a4.05,4.05,0,0,0-1.78.42l-3,1.51A.25.25,0,0,0,0,18V23.4a.25.25,0,0,0,.38.21l3.22-2a1,1,0,0,1,.86-.09c10,3.35,6.62,3.37,17.86-2.32a.51.51,0,0,0,.09-.86A2.48,2.48,0,0,0,20,17.85Z",
    style: {
      fill: "#000000"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Mobile);
export default __webpack_public_path__ + "static/media/step2-mobile.6f7ca1fe.svg";
export { ForwardRef as ReactComponent };